import { render, staticRenderFns } from "./MnpReject.vue?vue&type=template&id=735aaed7&"
import script from "./MnpReject.vue?vue&type=script&lang=js&"
export * from "./MnpReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports